import { Box, Typography } from '@mui/material';

import type { FunctionComponent } from 'react';

const WhatExpect: FunctionComponent = () => {
  return (
    <Box className="py-8">
      <Typography variant="body1">
        Crisis hotlines are an effective, efficient, and often free way for individuals to get the timely support they deserve when faced with an immediate crisis. The{' '}
        {process.env.NX_ORGANIZATION_NAME} is no different. Our goal is to effectively provide you with the support you deserve as well as resources to help you take the next step in your healing
        process. Below are some common FAQs for using the online hotline.
      </Typography>
      <Typography variant="body1" className="font-bold pt-4">
        How long can I talk to a support specialist?
      </Typography>
      <Typography variant="body1">
        Typically, hotline sessions last 30-60 minutes. In this time, our staff will listen to you and try to support and address your immediate concerns and needs.
      </Typography>

      <Typography variant="body1" className="font-bold pt-4">
        How can the support specialists help me?
      </Typography>
      <Typography variant="body1">
        In addition to listening and providing a space for you to share your experience, support specialists are trained to offer you resources and referrals to connect you with more support in your
        area or online. These are intended to help meet both your immediate and long-term needs as someone affected by sexual assault. We have referrals for mental health support, local sexual assault
        services, and legal or medical needs. We may also offer you links, book recommendations, and apps for more information about the effects of sexual assault and alternatives to long-term
        counseling.
      </Typography>
      <Typography variant="body1" className="font-bold pt-4">
        Will you have to report if I tell you what happened?
      </Typography>
      <Typography variant="body1">
        People who turn to the National Sexual Assault Hotline, especially young visitors, are often concerned that talking about what happened will require the support specialist to report to law
        enforcement. RAINN’s support specialists are trained to follow state reporting laws. We want to help keep young people safe and must share details with other adults if we have identifying
        information such as your name, location, or age. However we will never ask for this information. You only need to share what you feel comfortable sharing.
      </Typography>
    </Box>
  );
};
export default WhatExpect;
